import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { type ZoneUserAccess } from 'src/features/parkingManagement/types/zoneUserAccess.ts';
import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages.ts';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/zone-user-access/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    zone_id: z.string().min(1, { message: validationMessagesMap.validationErrorRequired }),
    user_roles: z.array(z.nativeEnum(MEMBERSHIP_ROLES)).nonempty(),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<ZoneUserAccess> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateZoneUserAccess, formSchema as CreateZoneUserAccessFormSchema };
export type { FormSchemaValues as CreateZoneUserAccessFormSchemaValues };
